<script>
import Datepicker from "vue3-datepicker";

export default {
    name: "StartEndTimes",
    components: {
        Datepicker,
    },
    emits: ["change"],
    props: {
        parentPage: {
            type: String,
            default() {
                return "";
            },
        },
        // eslint-disable-next-line vue/require-prop-type-constructor
        index: 0,
        start: null,
        end: null,
        errors: {
            type: Object,
            default() {
                return {
                    startDate: "",
                    endDate: "",
                };
            },
        },
        options: {
            type: Object,
            default() {
                return {
                    startDateContainerClass: "",
                    placeholder: "",
                    showEndDate: true,
                    format: "do LLL yyyy",
                    startDateLabel: "",
                    endDateLabel: "",
                };
            },
        },
        startDateClass: {
            type: String,
            default: "",
        },
        disabledEndDate: {
            type: Boolean,
            default: false,
        },
        disabledDates: {
            type: Object,
            default() {
                return {
                    from: "",
                    to: "",
                };
            },
        },
        required: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            startDate: null,
            endDate: null,
            formatedStartDate: "",
            formatedEndDate: "",
            startDayOfWeek: "",
            endDayOfWeek: "",
            copiedEndDate: null,
        };
    },
    methods: {
        setStartDate(date) {
            this.startDate = date;
        },

        dayOfWeekAsString(dayIndex) {
            return [
                "sunday",
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
            ][dayIndex] || "";
        },
        startDateSelected(skipEmit = false) {
            const d1 = new Date(this.startDate);
            const d2 = new Date(this.endDate);
            if (d1 > d2) {
                this.endDate = "";
            }
            const d = new Date(this.startDate);
            const day = d.getDate();
            const month = d.getMonth() + 1; // getMonth() returns month from 0 to 11
            const year = d.getFullYear();

            this.formatedStartDate = `${day}/${month}/${year}`;
            this.startDayOfWeek = this.dayOfWeekAsString(d.getDay());
            // Check if we displaying datepicker for one-off event
            if (this.endDate === "") {
                this.endDate = this.startDate;
                this.formatedEndDate = this.formatedStartDate;
                this.endDayOfWeek = this.startDayOfWeek;
            }
            if (!skipEmit) {
                this.$emit("change", this.getData());
            }
        },
        endDateSelected(skipEmit = false) {
            const d = new Date(this.endDate);
            const day = d.getDate();
            const month = d.getMonth() + 1; // getMonth() returns month from 0 to 11
            const year = d.getFullYear();

            this.formatedEndDate = `${day}/${month}/${year}`;
            this.endDayOfWeek = this.dayOfWeekAsString(d.getDay());

            if (!skipEmit) {
                this.$emit("change", this.getData());
            }
        },
        getData() {
            return {
                start: {
                    date: this.formatedStartDate,
                    weekday: this.startDayOfWeek,
                    plain: this.startDate,
                },
                end: {
                    date: this.formatedEndDate,
                    weekday: this.endDayOfWeek,
                    plain: this.endDate,
                },
            };
        },

        resetDates() {
            this.startDate = null
            this.endDate = null

            // Set dates to invalid date to prevent setting end date for Simple Event flow
            //this.startDate = new Date("asdasd");
            //this.endDate = new Date("asdasd");
        },
    },
    watch: {

        startDate() {
            this.startDateSelected();
        },

        endDate() {
            this.endDateSelected();
        },
        errors() {
            // console.log('start end times', this.errors)
        },

        start() {
            if (this.parentPage !== "mp") {
                return;
            }
            this.startDate = new Date(this.start);
        },

        end() {
            if (this.parentPage !== "mp") {
                return;
            }
            this.endDate = new Date(this.end);
        },
    },
    updated() {
        // if (typeof this.start === 'object' && this.start !== null) {
        //   this.formatedStartDate = this.start.date;
        //   this.startDate = this.start.plain;
        // }
        //
        // if (typeof this.end === 'object' && this.end !== null) {
        //   this.endDate = this.end.plain;
        //   this.formatedEndDate = this.end.date;
        // }
    },
    mounted() {
        if (this.parentPage === "new-modal") {
            if (this.start !== undefined) {
                this.startDate = this.start;
            }
            if (this.end !== undefined) {
                this.endDate = this.end;
            }
        }

        this.startDateSelected();
        if (this.parentPage === "course-weekly") {
            const courseDates = this.$storage.getStorageSync("courseDatesWeekly") || {};
            if (Object.keys(courseDates).length > 0) {
                this.startDate = new Date(courseDates.plainStartDate);
                this.endDate = new Date(courseDates.plainEndDate);
            }
        }

        if (this.parentPage === "course-daily") {
            const courseDates = this.$storage.getStorageSync("courseDatesDaily") || {};
            if (Object.keys(courseDates).length > 0) {
                this.startDate = new Date(courseDates.plainStartDate);
                this.endDate = new Date(courseDates.plainEndDate);
            }
        }

        if (this.parentPage === "course-weekly-holidays") {
            const courseDates = this.$storage.getStorageSync("courseDatesWeekly") || {};
            if (Object.keys(courseDates).length > 0) {
                const { holidays } = courseDates;
                this.startDate = holidays[this.index]?.holidayStartDate
                    ? new Date(holidays[this.index].holidayStartDate)
                    : new Date();

                this.endDate = holidays[this.index]?.holidayEndDate
                    ? new Date(holidays[this.index].holidayEndDate)
                    : new Date();
            }
        }

        if (this.parentPage === "course-daily-holidays") {
            const courseDates = this.$storage.getStorageSync("courseDatesDaily") || {};
            if (Object.keys(courseDates).length > 0) {
                if (this.start !== null) {
                    this.startDate = new Date(this.start);
                }

                if (this.end !== null) {
                    this.endDate = new Date(this.end);
                }
                // this.startDate = holidays[this.index]?.holidayStartDate ? new Date(holidays[this.index].holidayStartDate) : new Date();
                // this.endDate = holidays[this.index]?.holidayEndDate ? new Date(holidays[this.index].holidayEndDate) : new Date()
            }
        }

        if (this.parentPage === "one-off") {
            const data = this.$storage.getStorageSync("dateTimes") || [];
            if (data.length > 0) {
                const currentData = data[this.index];

                if (currentData !== undefined) {
                    this.startDate = new Date(currentData.startDate);
                    this.endDate = new Date(currentData.endDate);
                }
            }
        }

        if (this.parentPage === "mp") {
            if (this.start !== null) {
                this.startDate = new Date(this.start);
            }

            if (this.end !== null) {
                this.endDate = new Date(this.end);
            }
        }

        //Check this.startDate is not a indalid date
        if (this.startDate instanceof Date && isNaN(this.startDate)) {
            this.startDate = null;
        }
        if (this.endDate instanceof Date && isNaN(this.endDate)) {
            this.endDate = null;
        }
    },
};
</script>

<template>
    <div>
        <div class="d-flex flex-row justify-content-between date-range-container" data-test="datepicker-range">
            <div class="d-flex flex-column block-width" :class="options.startDateContainerClass">
                <div class="position-relative" data-test="datepicker-start">
                    <label class="show">{{ options.startDateLabel || "Start date" }}<span
                        v-if="required"
                        class="required-field"
                    >*</span></label>
                    <Datepicker
                        ref="startDate"
                        class="calendar-input text"
                        :class="{[startDateClass]: startDateClass !== ''}"
                        :id="'start-date-' + index"
                        name="start-date"
                        :placeholder="options.placeholder || 'Choose a date'"
                        :input-format="options.format"
                        :monday-first="true"
                        v-model="startDate"
                        :lower-limit="disabledDates.to || null"
                        :upper-limit="disabledDates.from || null"
                        calendat-button-icon="fa fa-calendar"
                    />
                    <svg class="calendar-icon" width="12" height="12" viewBox="0 0 12 12" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.625 0C2.72446 0 2.81984 0.0395088 2.89016 0.109835C2.96049 0.180161 3 0.275544 3 0.375V0.75H9V0.375C9 0.275544 9.03951 0.180161 9.10983 0.109835C9.18016 0.0395088 9.27554 0 9.375 0C9.47446 0 9.56984 0.0395088 9.64017 0.109835C9.71049 0.180161 9.75 0.275544 9.75 0.375V0.75H10.5C10.8978 0.75 11.2794 0.908035 11.5607 1.18934C11.842 1.47064 12 1.85218 12 2.25V10.5C12 10.8978 11.842 11.2794 11.5607 11.5607C11.2794 11.842 10.8978 12 10.5 12H1.5C1.10218 12 0.720644 11.842 0.43934 11.5607C0.158035 11.2794 0 10.8978 0 10.5V2.25C0 1.85218 0.158035 1.47064 0.43934 1.18934C0.720644 0.908035 1.10218 0.75 1.5 0.75H2.25V0.375C2.25 0.275544 2.28951 0.180161 2.35984 0.109835C2.43016 0.0395088 2.52554 0 2.625 0V0ZM0.75 3V10.5C0.75 10.6989 0.829018 10.8897 0.96967 11.0303C1.11032 11.171 1.30109 11.25 1.5 11.25H10.5C10.6989 11.25 10.8897 11.171 11.0303 11.0303C11.171 10.8897 11.25 10.6989 11.25 10.5V3H0.75Z"
                            fill="#999999"/>
                    </svg>
                </div>

                <div class="mt-2 error" :class="{'show': errors.startDate}">
                    {{ errors.startDate }}
                </div>
            </div>

            <div class="d-flex flex-column block-width ml-3 end-date-container" v-if="options.showEndDate !== false">
                <div class="position-relative" data-test="datepicker-end">
                    <label class="show">
                        {{ options.endDateLabel || "End date" }}
                        <span v-if="required"
                              class="required-field"
                        >*</span>
                    </label>
                    <Datepicker
                        :disabled="disabledEndDate"
                        ref="endDate"
                        class="calendar-input text"
                        :class="{startDateClass: startDateClass !== ''}"
                        :id="'end-date-' + index"
                        name="end-date"
                        placeholder="Choose a date"
                        :input-format="options.format"
                        :monday-first="true"
                        :lower-limit="startDate || null"
                        :upper-limit="disabledDates.from || null"
                        v-model="endDate"
                    />
                    <svg
                        class="calendar-icon"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path fill="#999999"
                              d="M2.625 0C2.72446 0 2.81984 0.0395088 2.89016 0.109835C2.96049 0.180161 3 0.275544 3 0.375V0.75H9V0.375C9 0.275544 9.03951 0.180161 9.10983 0.109835C9.18016 0.0395088 9.27554 0 9.375 0C9.47446 0 9.56984 0.0395088 9.64017 0.109835C9.71049 0.180161 9.75 0.275544 9.75 0.375V0.75H10.5C10.8978 0.75 11.2794 0.908035 11.5607 1.18934C11.842 1.47064 12 1.85218 12 2.25V10.5C12 10.8978 11.842 11.2794 11.5607 11.5607C11.2794 11.842 10.8978 12 10.5 12H1.5C1.10218 12 0.720644 11.842 0.43934 11.5607C0.158035 11.2794 0 10.8978 0 10.5V2.25C0 1.85218 0.158035 1.47064 0.43934 1.18934C0.720644 0.908035 1.10218 0.75 1.5 0.75H2.25V0.375C2.25 0.275544 2.28951 0.180161 2.35984 0.109835C2.43016 0.0395088 2.52554 0 2.625 0V0ZM0.75 3V10.5C0.75 10.6989 0.829018 10.8897 0.96967 11.0303C1.11032 11.171 1.30109 11.25 1.5 11.25H10.5C10.6989 11.25 10.8897 11.171 11.0303 11.0303C11.171 10.8897 11.25 10.6989 11.25 10.5V3H0.75Z"/>
                    </svg>
                </div>

                <div class="mt-2 error" :class="{'show': errors.endDate}">
                    {{ errors.endDate }}
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.calendar-icon {
    position: absolute;
    top: 62%;
    right: 16px;
}

.block-width {
    min-width: 334px;
}

label {
    font-size: 0.75rem;
}

@media only screen and (max-width: 768px) {
    .block-width {
        min-width: 100%;
        width: 100%;
    }

    .date-range-container {
        flex-wrap: wrap;
    }

    .end-date-container {
        margin-left: 0 !important;
    }
}
</style>
